import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { switchableComponentObj } from './dataset'

const SwitchableContent = ({ children }) => {
  const [currentContentObj, setContentObj] = useState(null)
  const handleSwitchContent = obj => {
    setContentObj(obj)
  }
  const RenderableComponent = currentContentObj && switchableComponentObj.find(({ value }) => value === currentContentObj.value).component

  return currentContentObj ? <RenderableComponent {...currentContentObj} handleClose={() => handleSwitchContent(null)} /> : children(handleSwitchContent)
}

SwitchableContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
}

export default SwitchableContent
